import React, { useContext, useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Navigate, useLocation } from "react-router";

import { UpgradePlan } from "../../Pages/Settings/AccountAndBilling/UpgradePlan";
import { AuthContext } from "../../../Context/AuthContext";
import { currentDateObject, getDateformat, getDateformatWise } from "../../../Utils/EqupTimezone";

export const IsTrialExpired = () => {
  const { t: locale } = useTranslation();
  const { pathname } = useLocation();
  const [show, setShow] = useState(false);
  const [redirectTo, setRedirectTo] = useState(false);
  const { userData } = useContext(AuthContext);
  const [showModal] = useState(true);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [planData, setPlanData] = useState(null);

  useEffect(() => {
    if (userData?.authData) {
      setPlanData(userData?.authData?.subscription || null);
    }
  }, [userData]);

  useEffect(() => {
    if (planData !== null) {
      setShow(true);
      if (checkIfPlanExpired(planData) || !planData.status) {
        setRedirectTo(true);
      }
    }
  }, [planData]);

  const checkIfPlanExpired = (plan) => {
    const currentDate = getDateformatWise(
      currentDateObject().utc(),
      "YYYY-MM-DD HH:mm:ss"
    );

    if (plan) {
      const planExpireDate = plan.trial_expiry_date
        ? plan.trial_expiry_date
        : plan.end_at;

      const endDate = getDateformat(planExpireDate).utc();
      const remainingDays = endDate < currentDate;
      return remainingDays;
    } else {
      return true;
    }
  };

  const closePopup = () => {
    setShow(false);
  };

  /******/
  if (redirectTo) {
    return <Navigate to={"/settings/accounts-and-billing"} />;
  }

  if (showUpgradeModal)
    return (
      <Modal
        className={"common modalXl edit-columns-modal"}
        onHide={() => {
          setShow(true);
          setShowUpgradeModal(false);
        }}
        show={showModal}
        backdrop={"static"}
        keyboard={false}
      >
        <Modal.Header closeVariant="white" closeButton className={"bg-primary"}>
          <Modal.Title className={"text-white secondary-font text-uppercase"}>
            {locale("pages:setting.account.plan.Upgrade Plan")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <UpgradePlan
            subscriptionId={planData?.subscription_id || ""}
            locale={locale}
          />
        </Modal.Body>
      </Modal>
    );

  if (
    planData?.payment_status === "failed" &&
    pathname !== "/settings/accounts-and-billing"
  )
    return (
      <Modal
        show={show}
        onHide={closePopup}
        centered
        style={{ zIndex: 9999 }}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>{locale("Notification")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <h2>
              Your payment has failed. Please retry to continue subscription.
            </h2>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <React.Fragment>
            <Button
              variant="primary"
              onClick={() => {
                setRedirectTo(true);
              }}
            >
              Retry Payment
            </Button>
          </React.Fragment>
        </Modal.Footer>
      </Modal>
    );

  return null;
};
